import { Entitlement } from 'store/user/reducer.types';

export default function getVodStripesExpiryDate(
    entitlements: Entitlement[],
    vodProductIds: (string | undefined)[] | undefined,
) {
    const rentedEntitlement = entitlements.filter((entitlement) =>
        vodProductIds?.includes(entitlement.productId),
    );

    return rentedEntitlement[0]?.expiryDate;
}
